export class User {
  public id: number;
  public name: string;
  public email: string;
  public mobile: string;
  public mobile_token: string;
  public profile_photo_path: string;
  public created_at: string;
  public updated_at: string;
  public profile_photo_url: string;
}
